import { useLayoutEffect, useState } from "react";

/**
 * True when the open dropdown menu inside `ref` doesn't fit below its button
 * but does fit above it, so it should open upward instead of being cut off.
 *
 * @param {object} ref ref of the <details> that owns the menu
 * @param {boolean} opened whether the menu is open
 */
function useMenuDropUp(ref, opened) {
  const [dropUp, setDropUp] = useState(false);

  useLayoutEffect(() => {
    if (!opened) {
      setDropUp(false);
      return;
    }
    const details = ref.current;
    const menu = details?.querySelector("summary + ul");
    if (!menu) return;
    const button = details.getBoundingClientRect();
    const needed = menu.offsetHeight + 8;
    const below = window.innerHeight - button.bottom;
    setDropUp(below < needed && button.top > below);
  }, [ref, opened]);

  return dropUp;
}

export default useMenuDropUp;
